<template>
  <div>
    <el-table
      v-if="creditNotes.length"
      :data="creditNotes"
      border
      style="width: 100%"
      row-key="credit_note_id"
    >
      <el-table-column
        prop="credit_note_number"
        label="Credit Note"
        width="150"
      />
      <el-table-column
        prop="date"
        label="Date"
        width="120"
        :formatter="format_date"
      />
      <el-table-column
        prop="status"
        label="Status"
        width="100"
      />
      <el-table-column
        prop="total"
        label="Total"
        width="120"
      />
      <el-table-column
        prop="remaining_credit"
        label="Unallocated"
        width="120"
      />
    </el-table>

    <div v-else>
      <p>No credit notes to display.</p>
    </div>
  </div>
</template>

<script>
import { xero_credit_notes } from '../../api/xero';
export default {
  name: 'XeroCreditNotes',
  props: { contact: { type: Object, required: true } },
  data() {
    return { creditNotes: [], loading: false };
  },
  mounted() {
    this.fetch_credit_notes();
  },
  methods: {
    async fetch_credit_notes() {
      if (!this.contact) return;
      this.loading = true;
      try {
        const response = await xero_credit_notes(this, { contact_id: this.contact.contact_id });
        this.creditNotes = response.data.credit_notes || [];
      } catch (err) {
        console.error('Failed to fetch Xero credit notes', err);
      } finally {
        this.loading = false;
      }
    },
    format_date(row, column, cellValue) {
      if (typeof cellValue === 'string') {
        const match = /\/Date\((\d+)([+-]\d+)?\)\//.exec(cellValue);
        if (match) {
          return new Date(parseInt(match[1], 10)).toLocaleDateString();
        }
      }
      return cellValue || '';
    }
  }
};
</script>
